/** Client-side helpers; server props from Book::Access are the source of truth. */

export function canAccessModule(access, moduleSlug) {
  if (access?.needs_company) return false
  const modules = access?.allowed_modules
  if (!modules?.length) return false
  return modules.includes(moduleSlug)
}

export function filterSections(access, moduleSlug, sections) {
  const allowed = access?.allowed_sections?.[moduleSlug]
  if (!allowed || allowed.includes("*")) return sections
  return sections.filter((item) => allowed.includes(item.slug))
}

export const MODULE_NAV = [
  { name: "Home", slug: "home", href: "/dashboard" },
  { name: "Items", slug: "items", href: "/items/catalog" },
  { name: "Sales", slug: "sales", href: "/sales/customers" },
  { name: "Purchases", slug: "purchases", href: "/purchases/vendors" },
  { name: "Time Tracking", slug: "time-tracking", href: "/time-tracking/projects" },
  { name: "Banking", slug: "banking", href: "/banking/accounts" },
  { name: "Employees", slug: "employee-management", href: "/employee-management/employees" },
  { name: "Accountant", slug: "accountant", href: "/accountant/manual-journals" },
  { name: "Reports", slug: "reports", href: "/reports/trial-balance" },
  { name: "Documents", slug: "documents", href: "/documents/library" },
  { name: "Credit Notes", slug: "credit-notes", href: "/credit-notes/all" },
]

export function visibleModules(access) {
  if (access?.needs_company) return []
  return MODULE_NAV.filter((item) => canAccessModule(access, item.slug))
}
